import '@utils/helpers/wdyr'
import '@styles/main.scss'

import { initTracking } from '@utils/helpers'
import type { AppProps } from 'next/app'
import Head from 'next/head'
import { useEffect } from 'react'

import { ContextProvider } from '../contexts'

interface Tracking {
  page: string
  form: string
  variant: string
}

interface AppPageProps {
  models?: Array<any>
  content?: Record<string, unknown>
  settings?: Record<string, unknown>
  title: string
  tracking: Tracking
  description: string
  isFinance?: boolean
}

const MyApp = ({ Component, pageProps }: AppProps<AppPageProps>) => {
  const metaTitleSuffix = pageProps?.isFinance
    ? pageProps?.settings?.finance_title_suffix
    : pageProps?.settings?.title_suffix
  const metaTitle = `${pageProps.title} | ${metaTitleSuffix}`
  const metaDesc = pageProps.description || ''

  useEffect(() => {
    initTracking(true)

    return () => {
      initTracking(false)
    }
  }, [])

  return (
    <ContextProvider>
      <>
        <Head>
          <meta
            key="viewport"
            name="viewport"
            content="width=device-width, initial-scale=1, viewport-fit=cover"
          />
          <meta key="robots" name="robots" content="noindex, nofollow" />
          <meta
            key="format-detection"
            name="format-detection"
            content="telephone=no"
          />
          <title key="title">{metaTitle}</title>
          <meta key="description" name="description" content={metaDesc} />
        </Head>
        <div className={`flex flex-col min-h-screen`}>
          <Component {...pageProps} />
        </div>
      </>
    </ContextProvider>
  )
}

export default MyApp
